import type { Task } from '@coachapp/shared';

const isCompletedTask = (status: Task['status']) =>
  status === 'DONE' || status === 'CANCELLED';

/** Open tasks first (newest created first), completed tasks at the end. */
export function sortTasks(tasks: Task[]): Task[] {
  return [...tasks].sort((a, b) => {
    const aCompleted = isCompletedTask(a.status);
    const bCompleted = isCompletedTask(b.status);
    if (aCompleted !== bCompleted) {
      return aCompleted ? 1 : -1;
    }
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
}
